import { notificationsConfig } from "../config/notifications.config.js";

/**
 * Normaliza query `limit` para `GET /notifications`.
 * @param {number|string} [limit]
 * @returns {number}
 */
export function normalizeNotificationsListLimit(limit) {
  const { defaultLimit, minLimit, maxLimit } = notificationsConfig;
  const parsed = Number(limit);

  if (!Number.isFinite(parsed)) return defaultLimit;

  const truncated = Math.trunc(parsed);
  if (truncated < minLimit) return defaultLimit;
  if (truncated > maxLimit) return maxLimit;
  return truncated;
}

/**
 * Extrai array bruto de notificações do envelope da API.
 * @param {*} response
 * @returns {Array}
 */
export function extractNotificationsList(response) {
  if (Array.isArray(response?.notifications)) {
    return response.notifications;
  }
  if (Array.isArray(response?.data?.notifications)) {
    return response.data.notifications;
  }
  if (Array.isArray(response?.data)) {
    return response.data;
  }
  if (Array.isArray(response)) {
    return response;
  }
  return [];
}
